import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../../reducers'
import { getApiUrl } from '../../apiService'
import { serializeQueryArgs } from './queryArgsSerialization/serializeQueryArgs'
import { waitUntil } from '../../lib/promise'
import { GetState } from '../types'
import { TAG_TYPES } from './tags'

export const serverApi = createApi({
  reducerPath: 'serverApi',
  keepUnusedDataFor: 60 * 60,
  serializeQueryArgs,

  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl(),
    prepareHeaders: async (headers, { getState }) => {
      await waitUntilAuthIsReady(getState as GetState)

      const { token, forceAuthAgainstEmail } = getHeaderData(getState() as RootState)
      token && headers.set('authorization', 'Bearer ' + token)
      forceAuthAgainstEmail && headers.set('x-force-auth-against-email', forceAuthAgainstEmail)

      return headers
    }
  }),
  tagTypes: TAG_TYPES,
  endpoints: () => ({})
})

function waitUntilAuthIsReady(getState: () => RootState) {
  const isAuthReady = () => {
    const { token, forceAuthAgainstEmail } = getHeaderData(getState())
    return Boolean(token || forceAuthAgainstEmail)
  }

  return waitUntil(isAuthReady, 80)
}

function getHeaderData(state: RootState) {
  return {
    token: state.user?.info.accessToken,
    forceAuthAgainstEmail: state.user?.info.__forceAuthAgainstEmail
  }
}
